import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Users from "@/pages/Users";
import Categories from "@/pages/Categories";
import Currencies from "@/pages/Currencies";
import Logs from "@/pages/Logs";
import SuperAdmins from "@/pages/SuperAdmins";
import Branches from "@/pages/Branches";
import Organization from "@/pages/Organization";

export default function Settings() {
  const { user } = useAuth();
  const isSuper = user.role === "super_admin";
  const isAdmin = user.role === "admin";

  return (
    <div className="space-y-6" data-testid="settings-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight">Settings</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manage your team and expense categories{isSuper ? ", currencies and super administrators" : ""}.
        </p>
      </div>

      <Tabs defaultValue="team">
        <TabsList className="rounded-sm">
          <TabsTrigger value="team" className="rounded-sm" data-testid="settings-tab-team">{isSuper ? "Tenant Users" : "Team"}</TabsTrigger>
          <TabsTrigger value="branches" className="rounded-sm" data-testid="settings-tab-branches">Branches</TabsTrigger>
          <TabsTrigger value="categories" className="rounded-sm" data-testid="settings-tab-categories">Categories</TabsTrigger>
          {isAdmin && <TabsTrigger value="organization" className="rounded-sm" data-testid="settings-tab-organization">Organization</TabsTrigger>}
          {isSuper && <TabsTrigger value="currencies" className="rounded-sm" data-testid="settings-tab-currencies">Currencies</TabsTrigger>}
          {isSuper && <TabsTrigger value="super-admins" className="rounded-sm" data-testid="settings-tab-super-admins">Super Admins</TabsTrigger>}
          <TabsTrigger value="activity" className="rounded-sm" data-testid="settings-tab-activity">Activity Log</TabsTrigger>
        </TabsList>
        <TabsContent value="team" className="mt-6"><Users /></TabsContent>
        <TabsContent value="branches" className="mt-6"><Branches /></TabsContent>
        <TabsContent value="categories" className="mt-6"><Categories /></TabsContent>
        {isAdmin && <TabsContent value="organization" className="mt-6"><Organization /></TabsContent>}
        {isSuper && <TabsContent value="currencies" className="mt-6"><Currencies /></TabsContent>}
        {isSuper && <TabsContent value="super-admins" className="mt-6"><SuperAdmins /></TabsContent>}
        <TabsContent value="activity" className="mt-6"><Logs /></TabsContent>
      </Tabs>
    </div>
  );
}
